import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { NewsService } from '../../services/obs/news.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { Router } from '@angular/router';
import { HeaderLoginService } from '../../services/header-login.service';
import { AccessService } from '../../services/access.service';
import { News } from '../../models/obs/news';
import { Message } from '../../models/message';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})

export class HeaderComponent implements OnInit {

  constructor(
    private sNews: NewsService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private headerLoginService: HeaderLoginService,
    private accesS: AccessService,
    private elementRef: ElementRef
  ) { }

  n: News = null;
  e: News = null;
  id_n: number = null;
  id_e: number = null;
  msg: Message;
  m1: any;
  m2: any[];

  //parte de icono login e informacio de incio de sesion
  isLoggedIn = false;
  IA = false;
  IO = false;
  usuario = '';
  rol: '';
  esDispositivoGrande = window.innerWidth >= 768;

  ngOnInit() {    
    this.getLastNews();
    this.onLogging();
    //esperamos gatillo de login para cambiar info de cabecera
    this.headerLoginService.shooterLogin.subscribe(data => {
      if (data) this.onLogging();
    });
  }

  /* Metodo para conseguir el primer enlace del usuario logeando para direccionarlo desde el combo superior*/
  idMBU = '';
  firstUrlLogged = '';
  getFirstModulByUser() {
    this.accesS.getFirstNameModulForPerson(this.idMBU).subscribe(
      {
        next: res => {
          this.firstUrlLogged = (res['data'])[0].modulo;
        },
        error: err => {
          console.log(err['message']);
        }
      }
    )
  }

  assignMenu(id_n: string, id_e: string) {
    this.m1 = [
      { title: 'Inicio', route: 'inicio' },
      { title: 'Actualidad', route: 'actualidad/' + id_n },
      { title: 'Publicaciones', route: 'publicacion' },
      { title: 'Encuentros', route: 'encuentro/' + id_e },
      { title: 'Pódcast', route: 'podcast' },
      { title: 'Redes', route: 'redes' },
      { title: 'Mapa de interrelaciones', route: 'mapas' },
      { title: 'Foros del Futuro', route: 'forosdelfuturo' }, //Agregado para foros
      //{ title: 'Visor geográfico', external: "https://geo.ceplan.gob.pe/"}
      //{ title: 'Adm', route: 'adm'}
    ];

    this.m2 = [
      { title: 'Megatendencias', route: 'megatendencia', submenus: [], isOpen: false },
      {
        title: 'Tendencias', route: 'tendencia', submenus: [
          { title: 'Tendencia Global', route: 'tendencia-global' },
          { title: 'Tendencia Nacional', route: 'tendencia-nacional' },
          { title: 'Tendencia Territorial', route: 'tendencia-territorial' },
          { title: 'Tendencia Sectorial', route: 'tendencia-sectorial' }
        ], isOpen: false
      },
      {
        title: 'Riesgos', route: 'riesgo', submenus: [
          { title: 'Riesgo Global', route: 'riesgo-global' },
          { title: 'Riesgo Territorial', route: 'riesgo-territorial' },
        ], isOpen: false
      },
      {
        title: 'Oportunidades', route: 'oportunidad', submenus: [
          { title: 'Oportunidad Global', route: 'oportunidad-global' },
          { title: 'Oportunidad Territorial', route: 'oportunidad-territorial' },
        ], isOpen: false
      },
      { title: 'Escenarios', route: 'escenario', submenus: [], isOpen: false },
      { title: 'Eventos Futuros', route: 'evento', submenus: [], isOpen: false }
    ];
  }

  getLastNews() {    
    this.sNews.getLastNews().subscribe(
      {
        next: res => {
          this.n = res['data'];          
          this.id_n = this.n[0].id;
          this.getLastEv();
        },
        error: err => { this.msg = err; }
      }
    );
  }

  getLastEv() {
    this.sNews.getLastEv().subscribe(
      {
        next: res => {
          this.e = res['data'];
          this.id_e = this.e[0].id;          
          this.assignMenu(this.n[0].id + '', this.e[0].id);
        },
        error: err => { this.msg = err; }
      }
    );
  }

  //metodo para cerrar la session 
  logOut(): void {
    this.tokenStorage.signOut();
    this.isLoggedIn = false;
    this.IA = false;
    this.IO = false
    this.router.navigate(['/'])
  }
  //Metodo para obtener datos de inicio de session
  onLogging(): void {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.usuario = this.tokenStorage.getUser().nombre;
      this.rol = this.tokenStorage.getUser().role;
      this.idMBU = this.tokenStorage.getUser().id;
      this.getFirstModulByUser();
      if (this.tokenStorage.getUser().isAllowed === true && this.tokenStorage.getUser().idteam === 1) {
        this.IA = true
      }
      if (this.tokenStorage.getUser().idteam == 1) {
        this.IO = true
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.esDispositivoGrande = window.innerWidth >= 768;
  }

  toggleSubMenu(menuItem: any): void {
    if (!this.esDispositivoGrande) {
      this.m2.forEach(item => {
        if (item !== menuItem) {
          item.isOpen = false;
        }
      });

      if (menuItem.submenus && menuItem.submenus.length > 0) {
        menuItem.isOpen = !menuItem.isOpen;
      } else if (menuItem.route) {
        this.router.navigate([menuItem.route]);
      }
      this.m1.forEach(menu => menu.isSelected = false);
      menuItem.isSelected = true;
    }
  }

  selectSubmenu(menuItem: any, submenu: any): void {
    this.m1.forEach(menu => menu.isSelected = false);
    menuItem.isSelected = true;
    submenu.isSelected = true;
  }
}
